<script lang="ts">
    import cn from 'classnames';

    import { SvgIcon } from '@uikit/svg-icon';

    import type { Props } from './types';

    import s from './item.module.css';

    export let iconName: Props['iconName'] = null;
    export let classes: Props['classes'] = '';
    export let withHover = true;
    export let testId: string | null = null;
</script>

<li class={cn(s.dropdownItem, classes, { [s.withHover]: withHover })} data-testid={testId}>
    <span class={s.dropdownItemInner} on:click>
        {#if iconName}
            <SvgIcon icon={iconName} />
        {/if}
        <slot />
    </span>
</li>
